// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/plan_auto_submit_notice_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PlanSubmissionKind, PlanTimeframe } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/plan_auto_submit_notice_model.proto.
 */
export const file_bffuser_v1_plan_auto_submit_notice_model: GenFile = /*@__PURE__*/
  fileDesc("Ci5iZmZ1c2VyL3YxL3BsYW5fYXV0b19zdWJtaXRfbm90aWNlX21vZGVsLnByb3RvEgpiZmZ1c2VyLnYxIt0BCgtOb3RpY2VkUGxhbhItCgRraW5kGAEgASgOMh8uYmZmdHlwZXMudjEuUGxhblN1Ym1pc3Npb25LaW5kEi0KCXRpbWVmcmFtZRgCIAEoDjIaLmJmZnR5cGVzLnYxLlBsYW5UaW1lZnJhbWUSJgoLdGFyZ2V0X2RhdGUYAyABKAsyES5nb29nbGUudHlwZS5EYXRlEigKCWFyZWFfY29kZRgEIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEh4KFnN1Ym1pc3Npb25fZW50aXR5X2NvZGUYBSABKAkijgEKFVVuc3VibWl0dGVkUGxhbk5vdGljZRIlCgRwbGFuGAEgASgLMhcuYmZmdXNlci52MS5Ob3RpY2VkUGxhbhI2CgZyZWFzb24YAiABKA4yJi5iZmZ1c2VyLnYxLlBsYW5BdXRvU3VibWl0Tm90aWNlUmVhc29uEhYKDmFza3NfdG9fc3VibWl0GAMgASgIIlcKGE1pc3NlZERlYWRsaW5lUGxhbk5vdGljZRIlCgRwbGFuGAEgASgLMhcuYmZmdXNlci52MS5Ob3RpY2VkUGxhbhIUCgxtaXNzZWRfa29tYXMYAiADKAUqvgUKGlBsYW5BdXRvU3VibWl0Tm90aWNlUmVhc29uEi4KKlBMQU5fQVVUT19TVUJNSVRfTk9USUNFX1JFQVNPTl9VTlNQRUNJRklFRBAAEjsKN1BMQU5fQVVUT19TVUJNSVRfTk9USUNFX1JFQVNPTl9VTlJFU09MVkVEX0lOQ09OU0lTVEVOQ1kQARItCilQTEFOX0FVVE9fU1VCTUlUX05PVElDRV9SRUFTT05fU1VQRVJTRURFRBACEi4KKlBMQU5fQVVUT19TVUJNSVRfTk9USUNFX1JFQVNPTl9FTVBUWV9TTE9UUxADEjMKL1BMQU5fQVVUT19TVUJNSVRfTk9USUNFX1JFQVNPTl9GSVJTVF9TVUJNSVNTSU9OEAQSPgo6UExBTl9BVVRPX1NVQk1JVF9OT1RJQ0VfUkVBU09OX0RFTUFORF9GT1JFQ0FTVF9VTkNPTkZJUk1FRBAFEjwKOFBMQU5fQVVUT19TVUJNSVRfTk9USUNFX1JFQVNPTl9NSVNTSU5HX0NPVU5URVJQQVJUWV9ST1dTEAYSNQoxUExBTl9BVVRPX1NVQk1JVF9OT1RJQ0VfUkVBU09OX0hFTERfUEFTVF9ERUFETElORRAHEjkKNVBMQU5fQVVUT19TVUJNSVRfTk9USUNFX1JFQVNPTl9TVUNDRVNTT1JfTk9UX0FDQ0VQVEVEEAgSOAo0UExBTl9BVVRPX1NVQk1JVF9OT1RJQ0VfUkVBU09OX1NVQ0NFU1NPUl9JTl9QUk9HUkVTUxAJEj4KOlBMQU5fQVVUT19TVUJNSVRfTk9USUNFX1JFQVNPTl9TVUNDRVNTT1JfR0VORVJBVElPTl9GQUlMRUQQChI1CjFQTEFOX0FVVE9fU1VCTUlUX05PVElDRV9SRUFTT05fV09SS0ZMT1dfU1VTUEVOREVEEAtCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_google_type_date]);

/**
 * 一覧の 1 行が指す計画 (計画種別 × 対象日 × エリア × 計画提出者コード) と、
 * 表示する計画断面。
 *
 * @generated from message bffuser.v1.NoticedPlan
 */
export type NoticedPlan = Message<"bffuser.v1.NoticedPlan"> & {
  /**
   * @generated from field: bfftypes.v1.PlanSubmissionKind kind = 1;
   */
  kind: PlanSubmissionKind;

  /**
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 2;
   */
  timeframe: PlanTimeframe;

  /**
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string submission_entity_code = 5;
   */
  submissionEntityCode: string;
};

/**
 * Describes the message bffuser.v1.NoticedPlan.
 * Use `create(NoticedPlanSchema)` to create a new message.
 */
export const NoticedPlanSchema: GenMessage<NoticedPlan> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_submit_notice_model, 0);

/**
 * 「自動で提出できていない計画」のバナーの 1 行。計画ごとに 1 行。
 *
 * @generated from message bffuser.v1.UnsubmittedPlanNotice
 */
export type UnsubmittedPlanNotice = Message<"bffuser.v1.UnsubmittedPlanNotice"> & {
  /**
   * @generated from field: bffuser.v1.NoticedPlan plan = 1;
   */
  plan?: NoticedPlan;

  /**
   * @generated from field: bffuser.v1.PlanAutoSubmitNoticeReason reason = 2;
   */
  reason: PlanAutoSubmitNoticeReason;

  /**
   * バナーの本文「理由を確認し、必要な計画は提出してください。」の対象か
   * (中断の計画は対象にしない。AC-PLC-082 ※)。
   *
   * @generated from field: bool asks_to_submit = 3;
   */
  asksToSubmit: boolean;
};

/**
 * Describes the message bffuser.v1.UnsubmittedPlanNotice.
 * Use `create(UnsubmittedPlanNoticeSchema)` to create a new message.
 */
export const UnsubmittedPlanNoticeSchema: GenMessage<UnsubmittedPlanNotice> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_submit_notice_model, 1);

/**
 * 「締切までに出し直せなかった計画」のバナーの 1 行 (AC-PAR-009)。
 *
 * @generated from message bffuser.v1.MissedDeadlinePlanNotice
 */
export type MissedDeadlinePlanNotice = Message<"bffuser.v1.MissedDeadlinePlanNotice"> & {
  /**
   * @generated from field: bffuser.v1.NoticedPlan plan = 1;
   */
  plan?: NoticedPlan;

  /**
   * GC までに出し直せなかったコマ (1〜48)。昇順・重複なし・空でない。
   *
   * @generated from field: repeated int32 missed_komas = 2;
   */
  missedKomas: number[];
};

/**
 * Describes the message bffuser.v1.MissedDeadlinePlanNotice.
 * Use `create(MissedDeadlinePlanNoticeSchema)` to create a new message.
 */
export const MissedDeadlinePlanNoticeSchema: GenMessage<MissedDeadlinePlanNotice> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_submit_notice_model, 2);

/**
 * 自動で提出できていない計画の理由 (docs/specs/plan-submit/plan-common.md
 * AC-PLC-082 の一覧の理由)。値は文言 1 つに 1 つ。
 * Mirrors internalapi.v1.PlanAutoSubmitNoticeReason.
 *
 * @generated from enum bffuser.v1.PlanAutoSubmitNoticeReason
 */
export enum PlanAutoSubmitNoticeReason {
  /**
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未解決の不整合があります
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_UNRESOLVED_INCONSISTENCY = 1;
   */
  UNRESOLVED_INCONSISTENCY = 1,

  /**
   * 作り直された後の計画があります
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_SUPERSEDED = 2;
   */
  SUPERSEDED = 2,

  /**
   * 未入力のコマがあります
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_EMPTY_SLOTS = 3;
   */
  EMPTY_SLOTS = 3,

  /**
   * この計画種別・エリア・計画提出者コードで初めての提出です
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_FIRST_SUBMISSION = 4;
   */
  FIRST_SUBMISSION = 4,

  /**
   * 需要想定の確定前に作った計画です
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_DEMAND_FORECAST_UNCONFIRMED = 5;
   */
  DEMAND_FORECAST_UNCONFIRMED = 5,

  /**
   * 登録済みの取引先の行が欠けています
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_MISSING_COUNTERPARTY_ROWS = 6;
   */
  MISSING_COUNTERPARTY_ROWS = 6,

  /**
   * 提出期限を過ぎたため 17:00 に提出します
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_HELD_PAST_DEADLINE = 7;
   */
  HELD_PAST_DEADLINE = 7,

  /**
   * 受け付けられていない版があります
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_SUCCESSOR_NOT_ACCEPTED = 8;
   */
  SUCCESSOR_NOT_ACCEPTED = 8,

  /**
   * 作業中の版があります
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_SUCCESSOR_IN_PROGRESS = 9;
   */
  SUCCESSOR_IN_PROGRESS = 9,

  /**
   * 作成に失敗した版があります
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_SUCCESSOR_GENERATION_FAILED = 10;
   */
  SUCCESSOR_GENERATION_FAILED = 10,

  /**
   * 中断したため提出できません。新しいワークフローで作り直してください
   *
   * @generated from enum value: PLAN_AUTO_SUBMIT_NOTICE_REASON_WORKFLOW_SUSPENDED = 11;
   */
  WORKFLOW_SUSPENDED = 11,
}

/**
 * Describes the enum bffuser.v1.PlanAutoSubmitNoticeReason.
 */
export const PlanAutoSubmitNoticeReasonSchema: GenEnum<PlanAutoSubmitNoticeReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_plan_auto_submit_notice_model, 0);

